export const ioCashModalOptions = [
  { label: 'Приходная операция', value: 'input' },
  { label: 'Расходная операция', value: 'output' }
];
